import { Suspense, lazy } from 'react';
import { useSearchParams } from 'react-router-dom';

// /labs — 3D hero spike (Chase, 2026-07-19), follow-up to the 3d-web-tools
// recon: three react-three-fiber hero concepts behind one URL, same
// switcher pattern as /templates. Not linked from the storefront.
//   ?v=1 Holo Slab   — floating graded-slab with iridescent holo material
//   ?v=2 Orbit Field — instanced particle galaxy with cursor gravity
//   ?v=3 Chrome Blob — distorted liquid-chrome sphere
// All Daybreak-branded (Sora, violet/cyan on near-black). Heavy three.js
// only loads on this route.
const Scene = lazy(() => import('../components/labs/LabScenes'));

const DEMOS = [
  { id: 1, name: 'Holo Slab', sub: 'An iridescent graded slab that tilts toward your cursor.' },
  { id: 2, name: 'Orbit Field', sub: 'Two thousand particles orbiting — your cursor bends the field.' },
  { id: 3, name: 'Chrome Blob', sub: 'Liquid chrome, breathing. Move to catch the light.' },
];

export default function LabsPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const active = Math.min(3, Math.max(1, parseInt(searchParams.get('v'), 10) || 1));
  const demo = DEMOS[active - 1];

  return (
    <div style={{ position: 'fixed', inset: 0, background: '#0a0912', fontFamily: "'Sora', sans-serif", overflow: 'hidden' }}>
      <Suspense fallback={<div style={{ color: '#9d97b8', padding: 40 }}>Loading scene…</div>}>
        <Scene variant={active} />
      </Suspense>

      <div style={{ position: 'absolute', top: 26, left: 34, color: '#f4f2ff', fontWeight: 800, letterSpacing: '0.02em', pointerEvents: 'none' }}>
        SHINY VAULT <span style={{ color: '#7c5cff' }}>LABS</span>
      </div>

      <div style={{ position: 'absolute', left: 34, bottom: 96, maxWidth: 440, pointerEvents: 'none' }}>
        <h1 style={{ color: '#ffffff', fontSize: 'clamp(1.8rem, 4vw, 2.8rem)', fontWeight: 800, letterSpacing: '-0.02em', margin: '0 0 8px' }}>
          {demo.name}
        </h1>
        <p style={{ color: '#9d97b8', fontSize: '0.95rem', lineHeight: 1.55, margin: 0 }}>{demo.sub}</p>
      </div>

      <div
        style={{
          position: 'fixed', bottom: 18, left: '50%', transform: 'translateX(-50%)', zIndex: 100,
          display: 'flex', gap: 6, background: 'rgba(20,20,28,0.85)', backdropFilter: 'blur(10px)',
          WebkitBackdropFilter: 'blur(10px)', borderRadius: 999, padding: 6,
          boxShadow: '0 8px 30px rgba(0,0,0,0.4)',
        }}
      >
        {DEMOS.map((d) => (
          <button
            key={d.id}
            onClick={() => setSearchParams({ v: String(d.id) })}
            style={{
              background: d.id === active ? '#ffffff' : 'transparent',
              color: d.id === active ? '#14141c' : '#b9b6c9',
              fontWeight: 700, fontSize: '0.8rem', padding: '9px 18px', borderRadius: 999,
              cursor: 'pointer', letterSpacing: '0.03em',
            }}
          >
            {d.id}. {d.name}
          </button>
        ))}
      </div>
    </div>
  );
}
